import { createFileRoute } from "@tanstack/react-router";

import NotFound from "@/components/not-found";

export const Route = createFileRoute("/(error)/page-not-found")({
  component: NotFound,
});
